var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"value":_vm.alert.properties.value,"type":_vm.alert.properties.type,"dismissible":""}},[_vm._v(" Currently, all your end-users have access to all connectors. If that is not intended, click "),_c('a',{on:{"click":function($event){return _vm.$emit('fix')}}},[_vm._v("here")]),_vm._v(" to go to the ACL section and change it. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }